(function () {

  'use strict';

  angular.module('eclipseApp.components').directive('rgLiveChat', function () {
    return {
      restrict: 'AE',
      scope: true,
      replace: true,
      templateUrl: 'modules/components/views/live-chat.html',
      link: function ($scope, $element, $attr) {        
        $scope.contentId = $attr.contentId || '/global/livesupport/shopping-cart/shopping-cart';
      }
    };
  });


})();

